import sha256 from 'js/auth/sha256'
import { pushToDataLayer } from 'js/pages/LandingPages/utils'

export function pushHashedEmailToDataLayer(email) {
  const state = JSON.parse(localStorage.getItem('state'))
  const redeem_code = state?.pricing?.selectedCoupon || ''

  if (!email) return
  sha256(email).then((hashedEmail) => {
    pushToDataLayer({
      event: 'hashed_email',
      hashed_email: hashedEmail,
      redeem_code,
    })
  })
}
